var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_7924_223534)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7924_223534)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 16,
    height: 16,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 16,
    height: 16,
    rx: 8,
    fill: "url(#paint0_linear_7924_223534)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 3.02028C7.14474 3.02028 4.01943 6.14559 4.01943 10.0009C4.01943 13.8561 7.14474 16.9814 11 16.9814C14.8553 16.9814 17.9806 13.8561 17.9806 10.0009C17.9806 6.14559 14.8553 3.02028 11 3.02028ZM3.98059 10.0009C3.98059 6.12415 7.12329 2.98145 11 2.98145C14.8767 2.98145 18.0194 6.12415 18.0194 10.0009C18.0194 13.8776 14.8767 17.0203 11 17.0203C7.12329 17.0203 3.98059 13.8776 3.98059 10.0009Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 8.03883C9.91688 8.03883 9.03883 8.91688 9.03883 10C9.03883 11.0831 9.91688 11.9612 11 11.9612C12.0831 11.9612 12.9612 11.0831 12.9612 10C12.9612 8.91688 12.0831 8.03883 11 8.03883ZM9 10C9 8.89543 9.89543 8 11 8C12.1046 8 13 8.89543 13 10C13 11.1046 12.1046 12 11 12C9.89543 12 9 11.1046 9 10Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 8.65993C10.26 8.65993 9.66017 9.25978 9.66017 9.99973C9.66017 10.7397 10.26 11.3395 11 11.3395C11.7399 11.3395 12.3398 10.7397 12.3398 9.99973C12.3398 9.25978 11.7399 8.65993 11 8.65993ZM9.62134 9.99973C9.62134 9.23833 10.2386 8.62109 11 8.62109C11.7614 8.62109 12.3786 9.23833 12.3786 9.99973C12.3786 10.7611 11.7614 11.3784 11 11.3784C10.2386 11.3784 9.62134 10.7611 9.62134 9.99973Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9806 2H11.0194V18H10.9806V2Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 9.98047L19 10.0193L3 10.0193L3 9.98047L19 9.98047Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.301 2H16.3399V18H16.301V2Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.32043 2H8.35927V18H8.32043V2Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6407 2H13.6796V18H13.6407V2Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.66016 2H5.69899V18H5.66016V2Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 15.3008L19 15.3396L3 15.3396L3 15.3008L19 15.3008Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 7.32031L19 7.35915L3 7.35915L3 7.32031L19 7.32031Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 12.6406L19 12.6795L3 12.6795L3 12.6406L19 12.6406Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 4.66016L19 4.69899L3 4.69899L3 4.66016L19 4.66016Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_7924_223534)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 10,
    r: 4,
    fill: "url(#paint1_linear_7924_223534)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_7924_223534)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 10H19C19 14.4183 15.4183 18 11 18C6.58172 18 3 14.4183 3 10Z",
    fill: "white",
    fillOpacity: 0.2
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_7924_223534",
    x: 0,
    y: 0,
    width: 22,
    height: 22,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7924_223534"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_7924_223534",
    result: "effect2_dropShadow_7924_223534"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_7924_223534",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_7924_223534",
    x: 4,
    y: 4,
    width: 14,
    height: 14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7924_223534"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_7924_223534",
    result: "effect2_dropShadow_7924_223534"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_7924_223534",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_7924_223534",
    x: -2.625,
    y: 4.375,
    width: 27.25,
    height: 19.25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 2.8125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_7924_223534"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_7924_223534",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7924_223534",
    x1: 11,
    y1: 2,
    x2: 11,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D5DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7924_223534",
    x1: 9,
    y1: 14,
    x2: 13,
    y2: 6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53389E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6941C6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7924_223534"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 16,
    height: 16,
    rx: 8,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMark);
export default __webpack_public_path__ + "static/media/logoMark.670a9c9c.svg";
export { ForwardRef as ReactComponent };